import BN from 'bn.js';
import {
	BigNum,
	PositionDirection,
	PRICE_PRECISION,
	PRICE_PRECISION_EXP,
} from '@drift-labs/sdk';
import {
	NEW_ORDER_TRIGGER_TOO_CLOSE_TO_LIMIT_WARNING,
	OPEN_POSITION_TRIGGER_TOO_CLOSE_TO_LIMIT_WARNING,
} from 'src/constants/warnings';
import UI_UTILS from 'src/utils/uiUtils';

/**
 * Checks if a limit price is too close to a trigger price for a trigger order.
 * Prices should be passed in at trade precision
 * Returns a warning message if the prices are too close, null otherwise.
 */
export const useLimitPriceVsTriggerPriceWarning = (
	triggerPrice: BN | undefined,
	limitPrice: BN | undefined,
	direction: 'long' | 'short',
	isExistingOrder: boolean
): string | null => {
	if (!triggerPrice || !limitPrice) {
		return null;
	}

	const bufferLimitPrice = UI_UTILS.getTriggerLimitBufferPrice(
		BigNum.from(triggerPrice, PRICE_PRECISION_EXP),
		direction === 'long' ? PositionDirection.LONG : PositionDirection.SHORT
	);

	if (bufferLimitPrice.eqZero()) {
		return null;
	}

	const isPastBuffer =
		direction === 'long'
			? limitPrice.lt(
					new BN(
						Number(bufferLimitPrice.toTradePrecision()) *
							PRICE_PRECISION.toNumber(),
						PRICE_PRECISION_EXP.toNumber()
					)
			  ) && limitPrice.gt(triggerPrice)
			: limitPrice.gt(
					new BN(
						Number(bufferLimitPrice.toTradePrecision()) *
							PRICE_PRECISION.toNumber(),
						PRICE_PRECISION_EXP.toNumber()
					)
			  ) && limitPrice.lt(triggerPrice);

	if (isPastBuffer) {
		if (isExistingOrder) {
			return OPEN_POSITION_TRIGGER_TOO_CLOSE_TO_LIMIT_WARNING;
		}
		return NEW_ORDER_TRIGGER_TOO_CLOSE_TO_LIMIT_WARNING;
	}

	return null;
};
